import React, { useContext, useEffect, useState } from "react"
import { WebsocketContext } from "../../context/WebsocketContext"
import { setCanvas } from "../../stores/canvasSlice"
import { useAppDispatch, useAppSelector } from "../../stores/hooks"
import { RootState } from "../../stores/store"
import FeedbackCanvasHeader from "./headers/FeedbackCanvasHeader"
import SvgLoader from "./svg/utils/SvgLoader"
import Board from "./svg/SvgCanvas/Board"
import "./FeedbackCanvas.scss"
import { t } from "i18next"

const FeedbackCanvas = (): React.JSX.Element => {
  const { connectionStatus, lastJsonMessage } = useContext(WebsocketContext)
  const [connections, setConnections] = useState<IConnection[]>([])
  const canvasStore = useAppSelector((state: RootState) => state.canvas)
  const [loadedCanvasData, setLoadedCanvasData] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  // Verifica se já existem dados no store quando a conexão está aberta
  useEffect(() => {
    if (connectionStatus === "Open" && canvasStore.feedback && canvasStore.feedback.id) {
      console.log("[FeedbackCanvas] Conexão aberta e dados já existem no store, carregando board")
      setLoadedCanvasData(true)
    }
  }, [connectionStatus, canvasStore.feedback])

  useEffect(() => {
    if (!lastJsonMessage) return

    console.log("[FeedbackCanvas] Mensagem recebida:", lastJsonMessage.action)

    switch (lastJsonMessage.action) {
      case "connected_list":
        setConnections([...lastJsonMessage.data])

        break
      case "new_connection":
        console.log("[FeedbackCanvas] new_connection recebida, carregando dados do canvas")
        setLoadedCanvasData(true)
        dispatch(
          setCanvas({
            ...canvasStore,
            feedback: lastJsonMessage.data.canvas,
            cards: [...lastJsonMessage.data.cards],
          })
        )
        break
      case "managefeedback":
        dispatch(
          setCanvas({
            ...canvasStore,
            feedback: lastJsonMessage.data,
          })
        )

        break
      case "connected":
        break
      case "people":
        dispatch(
          setCanvas({
            ...canvasStore,
            feedback: {
              ...canvasStore.feedback,
              users: [...lastJsonMessage.data],
            } as IFeedback,
          })
        )
        // Se já temos feedback com id, podemos considerar carregado
        if (canvasStore.feedback && canvasStore.feedback.id) {
          console.log("[FeedbackCanvas] People recebido e feedback já existe, definindo loadedCanvasData")
          setLoadedCanvasData(true)
        }
        break
      case "createcard":
        dispatch(
          setCanvas({
            ...canvasStore,
            cards: [...canvasStore.cards, lastJsonMessage.data],
          })
        )

        break
      case "editcard":
        console.log("[FeedbackCanvas] editcard", lastJsonMessage.data)
        console.log()

        const updatedCards = canvasStore.cards.map((card) => {
          if (card.id === lastJsonMessage.data.id) return lastJsonMessage.data

          return card
        })

        dispatch(setCanvas({ ...canvasStore, cards: [...updatedCards] }))

        break
      case "deletecard":
        console.log("[FeedbackCanvas] deletecard", lastJsonMessage.data)

        const deletedCards = canvasStore.cards.filter((card) => card.id !== lastJsonMessage.data.id)

        dispatch(setCanvas({ ...canvasStore, cards: [...deletedCards] }))
        break
      case "editfeedback":
        console.log("[FeedbackCanvas] editfeedback", lastJsonMessage.data)

        dispatch(setCanvas({ ...canvasStore, feedback: lastJsonMessage.data }))

        break
      default:
        break
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastJsonMessage])

  // Removido: efeitos de countdown/reload ao fechar conexão. O provider já cuida da reconexão

  const renderConnections = (): React.JSX.Element => {
    if (connections.length === 0) return <></>

    return (
      <div className={`connection-ids`} style={{ display: "none" }}>
        <ul>
          {connections.map((connection, index) => (
            <li key={index}>
              <div>{connection.connection_id}</div>
              <small>{connection.email}</small>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  if (!loadedCanvasData) {
    return (
      <SvgLoader>
        <div className="mt-3">
          <p>{t("loading.canvas")}</p>
          <p className="badge text-bg-primary">{connectionStatus}</p>
        </div>
      </SvgLoader>
    )
  }

  // Ao fechar, apenas exibimos o status visual; reconexão é automática pelo hook

  return (
    <div id="canvas-container-fixed">
      {renderConnections()}
      <div className={`connection-status ${connectionStatus.toLowerCase()}`}></div>
      <FeedbackCanvasHeader />
      <Board />
    </div>
  )
}

export default FeedbackCanvas
